import { useTranslation } from 'react-i18next';
import type { PatientRoomResponse } from '../../api/generated';
import { PatientRoomControllerApi } from '../../api/generated';
import { createApiConfiguration } from '../../api/apiConfig';
import { useAppDispatch } from '../../store/hooks';
import { showError } from '../../store/errorDialog/errorDialogSlice';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import styles from './DeleteRoomModal.module.css';

interface DeleteRoomModalProps {
  room: PatientRoomResponse;
  locationId: string;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteRoomModal = ({
  room,
  locationId,
  onClose,
  onDeleted
}: DeleteRoomModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleConfirm = async () => {
    try {
      const config = createApiConfiguration();
      const api = new PatientRoomControllerApi(config);
      await api.deletePatientRoom({ locationId, patientRoomId: room.id });
      onDeleted();
    } catch {
      dispatch(showError({ message: t('delete-room-error') }));
    }
  };

  return (
    <Modal
      title={t('delete-room-title')}
      onClose={onClose}
      width={480}
      footer={
        <div className={styles.footer}>
          <Button type="secondary" onClick={onClose}>
            {t('delete-room-cancel')}
          </Button>
          <Button type="primary" onClick={handleConfirm}>
            {t('delete-room-confirm')}
          </Button>
        </div>
      }
    >
      <p className={styles.message}>{t('delete-room-message', { name: room.description })}</p>
    </Modal>
  );
};
